import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';
import banners from './modules/banners';
import meuperfil from './modules/meuperfil';

import actionsFile from './actions';
import gettersFile from './getters';
import mutationsFile from './mutations';
import stateFile from './state';

Vue.use(Vuex);

const vuexLocalStorage = new VuexPersist({
  key: 'jdc-basic',
  storage: window.localStorage,
  reducer: state => ({
    user: state.user,
    userEmail: state.userEmail,
    token: state.token,
    emailSuccess: state.emailSuccess,
    dadosCompra: state.dadosCompra,
    dadosTransacao: state.dadosTransacao,
    motivosReembolso: state.motivosReembolso,
    assinaturaCancelada: state.assinaturaCancelada,
    concordouComVendedor: state.concordouComVendedor,
    alertaFormaPagamento: state.alertaFormaPagamento,
    afiliadoProdutor: state.afiliadoProdutor,
    bannerAds: state.banners,
    // Recobrança armada sobrevive a um F5 até o Card na lista consumi-la (FUS-2131).
    meuperfil: {
      assinaturaRecobrar: state.meuperfil.assinaturaRecobrar,
    },
  }),
});

const vuexLocalPersist = new VuexPersist({
  key: 'jdc-persist',
  storage: window.localStorage,
  reducer: state => ({
    publicPages: state.publicPages,
  }),
});

const { actions } = actionsFile;
const { getters } = gettersFile;
const { mutations } = mutationsFile;
const { state } = stateFile;

const modules = {
  banners,
  meuperfil,
};

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  modules,
  plugins: [vuexLocalStorage.plugin, vuexLocalPersist.plugin],
});
